import { setLoading } from "redux/actions/app.actions";
import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import { getServerErrorString } from "utils/common";

export const getAllLoyaltyRewardCatalogItems = (showLoading = true) => {
    return (dispatch) => {
        if (showLoading) dispatch(setLoading(true));
        return request("LoyaltyRewardCatalog", "get", null, true, null)
            .then((res) => {
                return {
                    status: "success",
                    data: res.data,
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                if (showLoading) dispatch(setLoading(false));
            });
    };
};

export const getLoyaltyRewardCatalogItem = (id) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`LoyaltyRewardCatalog/${id}`, "get", null, true, null)
            .then((res) => {
                return {
                    status: "success",
                    data: res.data,
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const createLoyaltyRewardCatalogItem = (values) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`LoyaltyRewardCatalog`, "post", values, true)
            .then((res) => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Reward catalog item created successfully"
                );
                return { status: "success", data: res?.data };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const updateLoyaltyRewardCatalogItem = (id, data) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`LoyaltyRewardCatalog/${id}`, "put", data, true)
            .then(() => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Reward catalog item updated successfully"
                );
                return {
                    status: "success",
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};
